module.exports = __webpack_public_path__ + "img/edit.cfdbc04d.svg";